xplenty.filter('indefiniteArticle', [
  function () {
    return function (value) {
      const res = value ? value.replace(/\bid\b/, 'ID') : '';
      return (res.match(/^[aeiouAEIOU]/) ? 'an ' : 'a ') + res;
    };
  },
]);
